import React from 'react';

import rrLogo from '../../../../assets/images/royal-ranger/Logo_Royal_Rangers.svg';

export default function BannerImage() {
    return (
            <img src={rrLogo} alt=""/>
    );
}
